interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/008029c4ca3238c7034e5a4be60d5bae/333b54039a066b237152bb16508c2149.jpeg"
              alt="Logo"
              className="h-14 w-auto object-contain"
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('mentora')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-purple-700' : 'text-white hover:text-yellow-400'
              }`}
            >
              Sobre a Mentora
            </button>
            <button
              onClick={() => scrollToSection('conteudo')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-purple-700' : 'text-white hover:text-yellow-400'
              }`}
            >
              O Curso
            </button>
            <button
              onClick={() => scrollToSection('depoimentos')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700 hover:text-purple-700' : 'text-white hover:text-yellow-400'
              }`}
            >
              Depoimentos
            </button>
            <a
              href="https://pay.kiwify.com.br/gZuAA7n"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-yellow-400 text-purple-900 px-6 py-2.5 rounded-full text-sm font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              Garanta sua vaga
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
